export default __webpack_public_path__ + "static/media/assessingEconomicEffectsMethodology.25f72881.pdf";